// src/com/sms_message/SmsMessageGql.js
import {gql} from '@apollo/client';
import ValueUtil from "../../model/ValueUtil";
import { TableColumnType } from '../../model/AppConst';

export const SmsMessageDictionary = {
    inputMap: {
        smsMessage: {
            toAdd:true, id: 'smsMessage', label: '문자내용', type: 'text',
            required: true,
            check: (value) => {return ValueUtil.textInRange(value,1,400)},
        },
        callBack: {
            toAdd:true, id: 'callBack', label: '발신번호', type: 'tel',
            required: true,
            check: (value) => {return /^\d{9,11}$/.test(value)},
        },
        receivers: {
            toAdd:true, id: 'receivers', label: '수신번호', type: 'tel',
            required: true,
            check: (value) => {return /^01\d{8,11}$/.test(value)},
        }
    },
    errorTitle: {
        Add: '문자 전송 오류',
        Get: '문자 목록 조회 오류'
    }
};

export const SmsMessageTableColumns = [
    { id: 'recvTel', label: '수신번호', width: 100, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'smsMessage', label: '문자내용', width: 250, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'callBack', label: '발신번호', width: 100, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'userName', label: '발신인', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'regTime', label: '전송일시', width: 170, show: true, option:{type: TableColumnType.DATETIME, align: 'center'} },
    { id: 'isCvoSms', label: '발신구분', width: 100, show: true, option:{align: 'center', print: (r,i,v) => {return v === 'Y' ? '관제시스템' : '사용자'}} }
];

/*


extend type Query {
	smsMessageList(dateFrom:String,dateTill:String): [SmsMessage]!
}

extend type Mutation {
    smsMessageAdd(smsMessage: InputSmsMessageAdd!): CommonResponse
}

type SmsMessage {
	smsId: Int
	regTime: String
	custId: String
	userId: String
	smsMessage: String
	isCvoSms: String
	seperateCount: Int
	recvTel: String
	callBack: String
	msgKind: String
	isMms: String
}


input InputSmsMessageAdd {
    smsMessage: String!
    receivers: [String!]!
    callBack: String!
}


*/

export const LIST_SMS_MESSAGE = gql`
    query ListSmsMessage($dateFrom:String,$dateTill:String) {
        smsMessageList(dateFrom: $dateFrom, dateTill: $dateTill) {
            smsId
            regTime
            custId
            userId
            userName
            smsMessage
            isCvoSms
            seperateCount
            recvTel
            callBack
            msgKind
            isMms
        }
    }
`;

export const ADD_SMS_MESSAGE = gql`
mutation AddSmsMessage($smsMessage: InputSmsMessageAdd!) {
    smsMessageAdd(smsMessage: $smsMessage) {
        ok
        message
    }
}
`;

